import React, { useState, useEffect, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import 'rsuite/dist/rsuite.min.css';
import config from "../common/Config";
import * as XLSX from 'xlsx';

const TransactionReport = () => {
    const [reportrange, setReportrange] = useState('');
    const [dates, setDates] = useState([null, null]);
    const [reportDate, setReportDate] = useState('');
    const salesOrderRef = useRef(null);
    const [salesRapOptions, setSalesRapOptions] = useState([]);
    const [salesRap, setSalesRap] = useState('');
    const [routeOptions, setRouteOptions] = useState([]);
    const [salesRoute, setSalesRoute] = useState('');
    const [recordsTotal, setRecordsTotal] = useState('');
    const accessToken = localStorage.getItem('accessToken');

    const handleDateChange = (value) => {
        setDates(value);
        let startDate = value[0] ? format(value[0], 'MM/dd/yyyy') : '';
        let endDate = value[1] ? format(value[1], 'MM/dd/yyyy') : '';
        setReportrange(startDate ? startDate + ' - ' + endDate : '');
        setReportDate(startDate + ' To Date : ' + endDate);
    };

    const fetchSalesRapOptions = async () => {
        const apiSalesRapUrl = `${config.API_URL}/getSalesRep`;
        try {
            const response = await fetch(apiSalesRapUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                }
            });
            const data = await response.json();
            const formattedOptions = data.data.map(item => ({
                label: `${item.first_name} ${item.last_name}`,
                value: item.id,
            }));
            setSalesRapOptions(formattedOptions);
        } catch (error) {
            console.error('Error fetching Sales Rep:', error);
        }
    };

    const fetchSalesRoute = async () => {
        const apiSalesRouteUrl = `${config.API_URL}/getRoute`;
        try {
            const response = await fetch(apiSalesRouteUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                }
            });
            const data = await response.json();
            const formattedOptions = data.data.map(item => ({
                label: `${item.route_number}`,
                value: item.id,
            }));
            setRouteOptions(formattedOptions);
        } catch (error) {
            console.error('Error fetching sales routes');
        }
    };

    const fetchReport = () => {
        const $table = $(salesOrderRef.current);
        const searchValue = $('#searchValue').val();

        if ($.fn.DataTable.isDataTable($table)) {
            $table.DataTable().destroy();
        }

        $table.DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: `${config.API_URL}/ws-transaction-report`,
                type: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                data: function (d) {
                    return $.extend({}, d, {
                        draw: d.draw,
                        start: d.start,
                        length: d.length,
                        searchValue: searchValue,
                        reportrange: reportrange,
                        sales_rep: salesRap,
                        route_id: salesRoute,
                        authorization: `Bearer ${accessToken}`,
                    });
                },
                dataSrc: function (json) {
                    if (json && json.data && Array.isArray(json.data)) {
                        setRecordsTotal(json.recordsTotal);
                        setReportDate(json.startdate + ' To Date : ' + json.enddate);
                    }
                    return Array.isArray(json.data) ? json.data : [];
                },
            },
            language: {
                paginate: {
                    first: 'First',
                    last: 'Last',
                    next: 'Next',
                    previous: 'Previous',
                },
                search: 'Search:',
            },
            columns: [
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return meta.row + 1;
                    }
                },
                { data: 'date' },
                {
                    data: "company",
                    render: (data, type, row) => {
                        const company = row.company || '';
                        const accountNo = row.accound_no || '';
                        return `${company} (${accountNo})`;
                    },
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        return '<a href="' + config.BASE_URL + '/reports/mis_report/print/' + row.id + '">' + row.reference_no + '</a>';
                    }
                },
                { data: 'grand_total' },
                { data: 'total_due' },
                { data: 'amount' },
                { data: 'sale_status' },
            ],
            columnDefs: [
                {
                    targets: [0, 1, 2, 3, 4, 5],
                    orderable: false
                }
            ],
            pageLength: 50,
        });
    };

    useEffect(() => {
        if (accessToken === null) {
            window.location.href = `${config.BASE_URL}/login`;
            return;
        }
        fetchReport();
        fetchSalesRapOptions();
        fetchSalesRoute();
    }, []);

    const searchFormData = () => {
        fetchReport();
    };

    const handleOptionChange = (event) => {
        setSalesRap(event.target.value);
    };

    const handleChangeRoute = (event) => {
        setSalesRoute(event.target.value);
    };

    const exportToExcel = async () => {
        const searchValue = $('#searchValue').val();
        const formData = new FormData();
        formData.append('draw', '1');
        formData.append('start', '0');
        formData.append("length", recordsTotal);
        formData.append("searchValue", searchValue);
        formData.append("reportrange", reportrange);
        formData.append("sales_rep", salesRap);
        formData.append("route_id", salesRoute);
        formData.append("authorization", `Bearer ${accessToken}`);

        const apiActivePdtUrl = `${config.API_URL}/ws-transaction-report`;

        try {
            const response = await fetch(apiActivePdtUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Failed to fetch Products');
            }

            const data = await response.json();
            const exportData = data.data.map(product => ({
                Date: product.date || '',
                "Customer (A/C)": product.company
                    ? `${product.company} (${product.accound_no || ''})`
                    : product.accound_no || '',
                "Order Number": product.reference_no || '',
                "Grand Total": product.grand_total || '',
                "Sales Rep Collected": product.amount || '',
                "Status": product.sale_status || ''
            }));
            const ws = XLSX.utils.json_to_sheet(exportData);

            Object.keys(ws).forEach(cell => {
                if (cell[0] !== '!') {
                    const cellValue = ws[cell].v;
                    if (!isNaN(cellValue)) {
                        ws[cell].t = 'n';
                    }
                }
            });

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Transactions Report');

            const now = new Date();
            const formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
            const formattedTime = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
            const filename = `Transactions-report-${formattedDate}-${formattedTime}.xlsx`;

            XLSX.writeFile(wb, filename);
        } catch (error) {
            console.error("Error exporting to Excel:", error);
        }
    };

    return (
        <div>
            <Header />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12">
                            <Link to="/Dashboard"><i className="fa fa-home"></i></Link>
                            <Link to="/reports/mis_report">Reports</Link>
                            <Link to="/reports/mis_report">Transactions report</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-container">
                <div className="container-fluid">
                    <div className="row">
                        <div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
                            <div className="row mb-3 padd-0">
                                <label className="col-sm-4" style={{ marginBottom: '5px' }} ><b>Select Date</b></label>
                                <div className="col-sm-8">
                                    <CommonDatePicker
                                        value={dates}
                                        showOneCalendar
                                        // placeholder="DD/MM/YYYY - DD/MM/YYYY"
                                        onChange={handleDateChange}
                                        format="dd/MM/yyyy"
                                        character=" - "
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
                            <div className="row mb-3 padd-0">
                                <label className="col-sm-4" style={{ marginBottom: '5px' }} ><b> Sales Rep</b></label>
                                <div className="col-sm-8">
                                    <Select
                                        value={salesRapOptions.find(option => option.value === salesRap) || null}
                                        onChange={option => setSalesRap(option ? option.value : '')}
                                        options={salesRapOptions}
                                        isClearable
                                        placeholder="Select a Sales Rep"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            // Fixes the overlapping problem of the component
                                            menu: provided => ({ ...provided, zIndex: 9999 }),
                                            menuPortal: provided => ({ ...provided, zIndex: 9999 })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
                            <div className="row mb-3 padd-0">
                                <label className="col-sm-4" style={{ marginBottom: '5px' }} ><b> Route</b></label>
                                <div className="col-sm-8">
                                    <Select
                                        value={routeOptions.find(option => option.value === salesRoute) || null}
                                        onChange={option => setSalesRoute(option ? option.value : '')}
                                        options={routeOptions}
                                        isClearable
                                        placeholder="Select Route"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            // Fixes the overlapping problem of the component
                                            menu: provided => ({ ...provided, zIndex: 9999 }),
                                            menuPortal: provided => ({ ...provided, zIndex: 9999 })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 col-lg-2 col-sm-6" style={{ float: 'left' }} >
                            <button
                                type="button"
                                onClick={searchFormData}
                                className="acceptbtn"
                                style={{ float: 'left' }}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                    <div className="total-manifests-area dashboard">
                        <p>
                            <b>Transactions Report From Date : {reportDate}</b>
                            <button className="create-catalogue-btn" onClick={exportToExcel} style={{ textTransform: 'capitalize' }}>
                                Export
                            </button>
                        </p>
                        <div className="verical-scrl-wrapper common-table autoheight-table misOrderReport" id="style-3">
                            <table className="table table-bordered resizable" id="misOrderReport" ref={salesOrderRef}>
                                <thead>
                                    <tr>
                                        <th>Sr.no</th>
                                        <th>Date</th>
                                        <th>customer (A/C)</th>
                                        <th>Inv. No</th>
                                        <th>Inv. Amt.</th>
                                        <th>Amt. Due</th>
                                        <th>Sales Rep Collected</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tfoot>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );

}

export default TransactionReport;
